import { QueryMe, ResultMe } from '@btsd/proto-generated-ts/users';
import { UserServiceClient } from '@btsd/proto-generated-ts/users.client';
import { GrpcWebTransport } from '@/api/transport.ts';

export class UsersService {
  private usersClient = new UserServiceClient(GrpcWebTransport);

  public async getMe(): Promise<ResultMe> {
    const req = { } as QueryMe;

    const { response } = await this.usersClient.getMe(req);

    return response;
  }

}

export const usersService = new UsersService();